import { ModalType } from 'component/common/modal/container/ModalContainer';
import { clearAllMarkers, clearNavigation } from 'map/control/common/clear';
import { PoiData } from 'map/types/object';
import useMapActionStore from 'stores/action';
import useFacilityStore from 'stores/facility';
import useTenantStore from 'stores/tenant';

// multi pois 처리하는 hook
const useMultiPoi = () => {
  const tenantStore = useTenantStore();
  const mapActionStore = useMapActionStore();
  const facilityStore = useFacilityStore();

  /**
   * ! multi pois는 일반적인 상황이 아니지만 예외 상황을 위해 처리
   * 이전에 poi를 하나 숨겨놓아서 여러개 poi라고 인식하는 경우가 있어서 처리함 (WIS)
   *
   * @param {PoiData[]} pois poi 목록
   * @param {(type: ModalType) => void} openModal
   */
  const handleMultiPoi = (
    // objectPosition: PositionStr,
    // findMultiPoiObjects: DataObject[],
    pois: PoiData[],
    openModal: (type: ModalType) => void,
  ) => {
    /**
     * ! 다중 poi 일 때 0번째 poi 로 무조건 보여주도록 처리 (2024 1202)
     */
    // const poiData: PoiData[] = findMultiPoiObjects[0].poiDataArr;
    const poiDataId = pois[0].id;
    const findTenant = tenantStore.rawTenants.find(item => item.content.poiId === poiDataId);
    // const excludeFirstPoiArr: PoiData[] = pois.slice(1);

    if (findTenant) {
      // TODO: 사용하지 않는 테넌트가 여러개일 경우 처리 필요
      if (!findTenant.used) {
        return;
      }

      clearAllMarkers();
      clearNavigation();
      mapActionStore.resetMapActions();
      facilityStore.resetCurrentFacilityId();
      tenantStore.resetCurrentTenant();

      // 첫번째 테넌트 제외한 배열
      // const excludeFirstTenantArr: TenantWithPointId[] = tenantStore.rawTenants
      //   .filter(rawTenant => excludeFirstPoiArr.some((poi: PoiData) => poi.id === rawTenant.content.poiId))
      //   .sort((a, b) => sortByLangOrder(a.name[langStore.currentLang], b.name[langStore.currentLang]));

      tenantStore.setCurrentTenant(findTenant);
      // tenantStore.setCurrentTenantArr([findTenant, ...excludeFirstTenantArr]);

      // 테넌트 목록 팝업 열기
      openModal(ModalType.tenant);

      // TODO: 다중 poi 일 경우 camera focus 할 position 변경해야 함
      // detail 의 position 하면 안됌
      // object 의 position 으로 할 경우 object find 해야 하고
      // poi 로 할 경우 poi id 로 poi position 찾아야 함
      // moveCamera(objectPosition);
    }
  };

  return { handleMultiPoi };
};
export default useMultiPoi;
